<template>
  <text :x="center[0] " :y="center[1]" :dy="index * 3" :fill="tagColor" text-anchor="middle" dominant-baseline="middle" v-for="(line, index) in tagLines" :key="index">
    <tspan
      v-for="(p, idx) in line"
      :key="idx"
      :font-size="p.Size || '1em'"
    >
      {{ p.FormattedValue }}
    </tspan>
  </text>
</template>

<script>
export default {
  name: "KobiViewTemplateTag",

  props: ['tag', 'element', 'center'],

  computed: {
    tagColor() {
      return this.tag.Color || '#000000';
    },
    tagLines() {
      const lines = [];
      let currentLine = [];
      for (const p of this.tag.Properties) {
        const value = this.element[p.Name] ?? '';
        const formatted = p.Format ? p.Format.replace('{0}', value) : value;

        formatted.split('\n').forEach((line, idx) => {
          if (idx > 0) {
            if (currentLine.length > 0) {
              lines.push(currentLine);
            }
            currentLine = [];
          }
          if (line !== '') {
            currentLine.push({
              FormattedValue: line,
              Size: p.Size || '1em'
            });
          }
        });
      }
      if (currentLine.length > 0) {
        lines.push(currentLine);
      }
      return lines;
    },
  }
};
</script>